export const removeFilhos = (lista: any): any => {
  return lista.map((item: any) => {
    // Create a copy of the item to avoid mutating the original
    const newItem = { ...item };

    // If the item has filhos, process them recursively
    if (newItem.filhos?.length > 0) {
      newItem.filhos = removeFilhos(newItem.filhos);
      // After processing, if filhos is empty, remove the filhos property
      if (newItem.filhos.length === 0) {
        const { filhos, ...rest } = newItem;
        return rest;
      }
    } else {
      // If filhos is empty or undefined, remove the filhos property
      const { filhos, ...rest } = newItem;
      return rest;
    }

    return newItem;
  });
};
